import React from 'react';
import ContentLoader from 'react-content-loader';

const LoaderDetails = () => {
  return (
    <ContentLoader
      speed={2}
      width={811}
      height={96}
      viewBox={`0 0 811 96`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb">
      <>
        <rect x="106" y="15" rx="3" ry="3" width="45" height="12" />
        <rect x="248" y="15" rx="3" ry="3" width="100" height="12" />
        <rect x="462" y="15" rx="3" ry="3" width="78" height="12" />
        <rect x="635" y="15" rx="3" ry="3" width="100" height="26" />
        <rect x="15" y="68" rx="3" ry="3" width="15" height="15" />
        <rect x="40" y="72" rx="3" ry="3" width="20" height="12" />
        <rect x="106" y="72" rx="3" ry="3" width="65" height="12" />
        <rect x="248" y="72" rx="3" ry="3" width="110" height="12" />
        <rect x="462" y="72" rx="3" ry="3" width="20" height="12" />
        <rect x="635" y="72" rx="3" ry="3" width="80" height="12" />
      </>
    </ContentLoader>
  );
};

export default LoaderDetails;
